import { SkeletonButton, SkeletonLine } from "./SkeletonElements";

const PaginatorSkeleton = ({ showTotalItems }) => {
    return (
        <div className="flex items-center gap-1 sm:gap-2 h-8 sm:justify-end">
            {/* Show total items skeleton */}
            {showTotalItems && (
                <div className="text-xs text-base-content/50 ml-2">
                    <SkeletonLine width="w-16" height="h-3" />
                </div>
            )}

            <div className="flex items-center gap-1 sm:gap-2">
                {/* Loading skeleton for previous button */}
                <SkeletonButton width="w-8" height="h-8" className="btn-sm" />

                {/* Loading skeleton for page info */}
                <SkeletonLine
                    width="w-16"
                    height="h-8"
                    className="px-3 sm:px-4 py-1 rounded-md border border-base-300"
                />

                {/* Loading skeleton for next button */}
                <SkeletonButton width="w-8" height="h-8" className="btn-sm" />
            </div>
        </div>
    );
};

export default PaginatorSkeleton;
